import osm2geojson from "osm2geojson-lite";
import { RATE_LIMITER } from "../constants/mapConstants";

// Cache for boundary data to avoid repeated API calls
const boundaryCache = new Map();

export const fetchBoundaryData = async (url, cacheKey) => {
  // Check cache first
  if (boundaryCache.has(cacheKey)) {
    return boundaryCache.get(cacheKey);
  }

  // Apply rate limiting
  await RATE_LIMITER.throttle();

  try {
    const response = await fetch(url);
    
    if (response.status === 429) {
      throw new Error('Rate limit exceeded. Please wait a moment before trying again.');
    }
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      throw new Error("Expected JSON response but received: " + contentType);
    }
    
    const data = await response.json();
    
    // Cache the result
    boundaryCache.set(cacheKey, data);
    
    return data;
  } catch (error) {
    console.error('Error fetching boundary data:', error);
    throw error;
  }
};

export const convertOsmToGeoJson = (osmData) => {
  const converted = osm2geojson(osmData);
  
  // Handle both FeatureCollection and direct geometry
  if (converted.type === 'FeatureCollection') {
    return converted;
  } else if (converted.type && converted.coordinates) {
    return {
      type: 'FeatureCollection',
      features: [{
        type: 'Feature',
        properties: {},
        geometry: converted
      }]
    };
  }
  
  return null;
};

export const createBoundaryUrl = (relId) => {
  return `https://overpass-api.de/api/interpreter?data=[out:json];relation(${relId});out geom;`;
};